import { createStructuredSelector } from 'reselect'

import {
  QUESTION_LIST,
  QUESTION_LIST_SUCCESS, 
  QUESTION_LIST_ERROR,
  QUESTION_PAGE_SET,
  QUESTION_SEARCH_SET,
  QUESTION_SEARCH_CHANGE,
  QUESTION_SEARCH_SECTION_LIST,
  QUESTION_SEARCH_SECTION_LIST_SUCCESS,
  QUESTION_SEARCH_SECTION_LIST_ERROR, 
  QUESTION_ADD_SET,
  QUESTION_ADD_MODAL_SET,
  QUESTION_ADD,
  QUESTION_ADD_SUCCESS,
  QUESTION_ADD_ERROR,
  QUESTION_ADD_CHANGE,
  QUESTION_DETAIL,
  QUESTION_DETAIL_SUCCESS,
  QUESTION_DETAIL_ERROR,
  QUESTION_VIEW_MODAL_SET,
  QUESTION_EDIT_CHANGE,
  QUESTION_EDIT_MODAL_SET,
  QUESTION_UPDATE,
  QUESTION_UPDATE_SUCCESS,
  QUESTION_UPDATE_ERROR,
  QUESTION_VIEW_TAB_SET,
  QUESTION_UPLOAD_SET,
  QUESTION_UPLOAD_SET_SUCCESS,
  QUESTION_UPLOAD_SET_ERROR,
  QUESTION_UPLOAD_RESET
} from '../../actions';

export const NAME = 'question';

export const QuestionList = (page, num_page, orderBy, filters, stateFilter, display) => ({
  type: QUESTION_LIST,
  payload: { page: page, num_page: num_page, orderBy: orderBy, filters: filters, filtersState: stateFilter, display: display }
});

export const QuestionListSuccess = (data) => ({
  type: QUESTION_LIST_SUCCESS,
  payload: data
});

export const QuestionListError = (error) => ({
  type: QUESTION_LIST_ERROR,
  payload: error
});

export const QuestionPageSet = (data) => ({
  type: QUESTION_PAGE_SET,
  payload: data
});

export const QuestionSearchSet = (data) => ({
  type: QUESTION_SEARCH_SET,
  payload: data
});

export const QuestionSearchChangeSet = (data) => ({
  type: QUESTION_SEARCH_CHANGE,
  payload: data
});

export const QuestionSearchSectionList = (data) => ({
  type: QUESTION_SEARCH_SECTION_LIST,
  payload: data
});

export const QuestionSearchSectionListSuccess = (message) => ({
  type: QUESTION_SEARCH_SECTION_LIST_SUCCESS,
  payload: message
});

export const QuestionSearchSectionListError = (error) => ({
  type: QUESTION_SEARCH_SECTION_LIST_ERROR,
  payload: error
}); 

export const QuestionAddChangeSet = (data) => ({
  type: QUESTION_ADD_CHANGE,
  payload: data
});

export const QuestionAddSet = (data) => ({
  type: QUESTION_ADD_SET,
  payload: data
});

export const QuestionAddModalSet = (data) => ({
  type: QUESTION_ADD_MODAL_SET,
  payload: data
});

export const QuestionAdd = (data) => ({
  type: QUESTION_ADD,
  payload: data
});

export const QuestionAddSuccess = (message) => ({
  type: QUESTION_ADD_SUCCESS,
  payload: message
});

export const QuestionAddError = (error) => ({
  type: QUESTION_ADD_ERROR,
  payload: error
});

export const QuestionDetail = (data) => ({
  type: QUESTION_DETAIL,
  payload: data
});

export const QuestionDetailSuccess = (data) => ({
  type: QUESTION_DETAIL_SUCCESS,
  payload: data
});

export const QuestionDetailError = (error) => ({
  type: QUESTION_DETAIL_ERROR,
  payload: error
});

export const QuestionViewModalSet = (data) => ({
  type: QUESTION_VIEW_MODAL_SET,
  payload: data
});

export const QuestionEditModalSet = (data) => ({
  type: QUESTION_EDIT_MODAL_SET,
  payload: data
});

export const QuestionEditChangeSet = (data) => ({
  type: QUESTION_EDIT_CHANGE,
  payload: data
});

export const QuestionUpdate = (data) => ({
  type: QUESTION_UPDATE,
  payload: data
});

export const QuestionUpdateSuccess = (message) => ({
  type: QUESTION_UPDATE_SUCCESS,
  payload: message.message
});

export const QuestionUpdateError = (error) => ({
  type: QUESTION_UPDATE_ERROR,
  payload: error
});

export const QuestionViewTabSet = (data) => ({
  type: QUESTION_VIEW_TAB_SET,
  payload: data
});

export const QuestionUploadSet = (file) => ({
  type: QUESTION_UPLOAD_SET,
  payload: { file },
});

export const QuestionUploadSetSuccess = (items) => ({
  type: QUESTION_UPLOAD_SET_SUCCESS,
  payload: items,
});

export const QuestionUploadSetError = (error) => ({
  type: QUESTION_UPLOAD_SET_ERROR,
  payload: error,
});

export const QuestionUploadReset= () => ({
  type: QUESTION_UPLOAD_RESET
});

const question = (state) => state[NAME];

export const QuestionSelector = createStructuredSelector({
  question
})
 